import { FaGithub, FaLinkedin, FaArrowRight } from 'react-icons/fa';
import profile from '../shared/assets/profile.jpeg';

const GITHUB_URL = 'https://github.com/gardner-nick';
const LINKEDIN_URL = 'https://www.linkedin.com/in/nicholas-gardner-7b588a105/';

export function Hero() {
  return (
    <section
      id="home"
      className="mx-auto grid max-w-content grid-cols-1 items-center gap-10 px-5 pb-16 pt-28 md:grid-cols-[1.1fr_0.9fr] md:gap-12 md:pt-32"
    >
      {/* Left: intro */}
      <div className="animate-fade-up">
        <p className="font-mono text-sm text-accent">$ whoami</p>
        <h1 className="mt-3 font-mono text-4xl font-bold leading-tight tracking-tight text-fg sm:text-5xl lg:text-6xl">
          Nick Gardner
          <span className="ml-1 inline-block w-[0.6ch] animate-blink text-accent">_</span>
        </h1>
        <p className="mt-3 font-mono text-lg text-fg/90 sm:text-xl">Full Stack Software Engineer</p>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-muted">
          Specializing in building scalable web applications and cloud infrastructure. Passionate
          about taking projects from concept to production, with a focus on reliability,
          performance, and user experience.
        </p>

        <div className="mt-7 flex flex-wrap items-center gap-3">
          <a
            href="#projects"
            className="inline-flex items-center gap-2 rounded-lg bg-accent px-5 py-2.5 font-mono text-sm font-medium text-bg shadow-glow transition-transform hover:-translate-y-0.5"
          >
            View work <FaArrowRight aria-hidden className="text-xs" />
          </a>
          <a
            href={GITHUB_URL}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 rounded-lg border border-border bg-elevated px-5 py-2.5 font-mono text-sm text-fg transition-colors hover:border-accent/60 hover:text-accent"
          >
            <FaGithub aria-hidden /> GitHub
          </a>
          <a
            href={LINKEDIN_URL}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 rounded-lg border border-border bg-elevated px-5 py-2.5 font-mono text-sm text-fg transition-colors hover:border-accent/60 hover:text-accent"
          >
            <FaLinkedin aria-hidden /> LinkedIn
          </a>
        </div>
      </div>

      {/* Right: terminal window with avatar */}
      <div className="terminal-card animate-fade-up overflow-hidden">
        <div className="flex items-center gap-3 border-b border-border px-4 py-3">
          <span className="win-dots relative block h-2.5 w-2.5" aria-hidden />
          <span className="ml-8 font-mono text-xs text-muted">~/nick-gardner — zsh</span>
        </div>
        <div className="p-6">
          <div className="mb-5 flex justify-center">
            <img
              src={profile}
              alt="Nick Gardner"
              width={144}
              height={144}
              className="h-36 w-36 rounded-full border-2 border-accent/40 object-cover object-[center_20%] shadow-glow"
            />
          </div>
          <pre className="overflow-x-auto font-mono text-sm leading-relaxed text-fg/90">
            {`> const nick = {
    role:    `}
            <span className="text-accent">'engineer'</span>
            {`,
    focus:   [`}
            <span className="text-cyan">'cloud'</span>
            {`, `}
            <span className="text-cyan">'web'</span>
            {`],
    status:  `}
            <span className="text-accent">'open to connect'</span>
            {`,
  }`}
          </pre>
        </div>
      </div>
    </section>
  );
}
